import { isProductionHost } from './environment';

/**
 * Which HubSpot portal a page is talking to. Production runs on the live
 * portal; master and local development run on the sandbox, because the master
 * backend's token is the sandbox's. A link has to open the portal the record
 * lives in, so it follows the host the same way the Chargebee link does
 * (AddSalesPerson).
 */
const LIVE_PORTAL = '8498425';
const SANDBOX_PORTAL = '51356017';

/** HubSpot's own object types for a deal, a contact and a ticket. */
export const HUBSPOT_DEAL = '0-3';
export const HUBSPOT_CONTACT = '0-1';
export const HUBSPOT_TICKET = '0-5';

export const hubspotPortalId = (host: string = window.location.host): string => (
  isProductionHost(host) ? LIVE_PORTAL : SANDBOX_PORTAL
);

export const hubspotRecordUrl = (
  objectType: string,
  id: string,
  host: string = window.location.host,
): string => `https://app.hubspot.com/contacts/${hubspotPortalId(host)}/record/${objectType}/${id}`;

export const hubspotDealUrl = (id: string, host?: string): string => (
  hubspotRecordUrl(HUBSPOT_DEAL, id, host)
);

export const hubspotContactUrl = (id: string, host?: string): string => (
  hubspotRecordUrl(HUBSPOT_CONTACT, id, host)
);

/**
 * A Building record. The type id is the portal's own (the sandbox's differs
 * from live), so it comes from the backend with the order; without it there
 * is no link.
 */
export const hubspotBuildingUrl = (
  objectType: string | undefined,
  id: string,
  host?: string,
): string | undefined => (objectType ? hubspotRecordUrl(objectType, id, host) : undefined);

/** The ticket an order's progress is reported on. */
export const hubspotTicketUrl = (id: string, host?: string): string => (
  hubspotRecordUrl(HUBSPOT_TICKET, id, host)
);
